import React, { useState, useEffect } from 'react';
import './WelcomeScreen.css';

const WelcomeScreen = ({ onClose }) => {
  const [message, setMessage] = useState('Selamat datang di Sahabat Kakao!');
  const [isEditing, setIsEditing] = useState(false);
  const [editMessage, setEditMessage] = useState('');

  useEffect(() => {
    const storedMessage = localStorage.getItem('welcomeMessage');
    if (storedMessage) {
      setMessage(storedMessage);
    }
  }, []);

  const handleEdit = () => {
    setIsEditing(true);
    setEditMessage(message);
  };

  const handleSave = () => {
    setMessage(editMessage);
    localStorage.setItem('welcomeMessage', editMessage);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditMessage('');
  };

  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <h1>{message}</h1>
        {isEditing ? (
          <div className="edit-section">
            <input
              type="text"
              value={editMessage}
              onChange={(e) => setEditMessage(e.target.value)}
              className="edit-input"
            />
            <button onClick={handleSave} className="save-btn">Simpan</button>
            <button onClick={handleCancel} className="cancel-btn">Batal</button>
          </div>
        ) : (
          <button onClick={handleEdit} className="edit-btn">Edit Pesan</button>
        )}
        <button onClick={onClose} className="close-btn">Tutup</button>
      </div>
    </div>
  );
};

export default WelcomeScreen;
